import axios from "../axios";

export async function printQuality(payload) {
  return axios.put(`/quality/qualities/${payload.id}/print`, {
    printType: payload.printType || payload.print_type || "standard",
    include_images: payload.include_images || false,
  });
}

export async function fetchQualityInstructions(controller) {
  return axios({
    method: "get",
    url: "quality/instructions",
    params: controller,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchQualityInstruction(id) {
  return axios.get(`/quality/instructions/` + id);
}

export async function createQualityInstruction(payload) {
  return axios
    .post(`/quality/instructions`, { instruction: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function updateQualityInstruction(payload) {
  return axios
    .put(`/quality/instructions/${payload.id}`, { instruction: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function deleteQualityInstruction(payload) {
  const instruction = payload.instruction;
  return axios
    .delete(`/quality/instructions/${instruction.id}`, {
      data: JSON.stringify({
        instruction,
      }),
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function fetchQualitys(controller) {
  return axios({
    method: "get",
    url: "quality/qualities",
    params: controller,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchQuality(id) {
  return axios.get(`/quality/qualities/` + id);
}

export async function createQuality(payload) {
  return axios
    .post(`/quality/qualities`, { quality: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function updateQuality(payload) {
  return axios
    .put(`/quality/qualities/${payload.id}`, { quality: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function deleteQuality(payload) {
  const quality = payload.quality;
  return axios
    .delete(`/quality/qualities/${quality.quality_id}`, {
      data: JSON.stringify({
        quality,
      }),
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

// Revision functions
export async function createQualityRevision(qualityId) {
  return axios
    .post(`/quality/qualities/${qualityId}/create_revision`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function approveQualityRevision(qualityId, revisionId) {
  return axios
    .post(`/quality/qualities/${qualityId}/approve_revision`, {
      revision_id: revisionId,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function fetchQualityRevisions(qualityId) {
  return axios
    .get(`/quality/qualities/${qualityId}/revisions`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchQualityRevision(qualityId, revisionId) {
  return axios
    .get(`/quality/qualities/${qualityId}/revisions/${revisionId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function updateQualityRevision(qualityId, revisionId, payload) {
  return axios
    .put(`/quality/qualities/${qualityId}/revisions/${revisionId}`, {
      revision: payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function approveQualityRevisionUser(qualityId, revisionId, approved, comment) {
  return axios
    .post(`/quality/qualities/${qualityId}/revisions/${revisionId}/approve_user`, {
      approved: approved,
      comment: comment || "",
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function notifyUsersAboutRevision(qualityId, revisionId, userIds) {
  return axios
    .post(`/quality/qualities/${qualityId}/revisions/${revisionId}/notify_users`, {
      user_ids: userIds,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function exportQualityRevisionPDF(qualityId, revisionId) {
  return axios
    .get(`/quality/qualities/${qualityId}/revisions/${revisionId}/export_pdf`, {
      responseType: 'blob',
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}
